import styled from "styled-components";
import { theme } from "../../styles/theme";

// Mesma estrutura do WarningBannerAssignature (ver
// ../warningBannerAssignature/styles.js), mas de confirmação: fundo cinza
// claro (igual aos cards da página Relatórios - ver pages/relatorio/styles.js,
// ColGraph03/IndicatorsCard, ambos #F8F8F9/Cinza_13) em vez de amarelo de
// alerta, e ícone de lápis em vez de aviso.
export const ConfirmationBanner = styled.div`
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth || "768px"};
  margin-top: 16px;
  padding: 16px;

  display: flex;
  align-items: center;
  gap: 12px;

  border-radius: 12px;
  background-color: ${theme.colors.gray.Cinza_13};

  img {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  .confirmation-content {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  p {
    flex: 1;
    text-align: left;
    font-size: ${theme.typography.fontSize.auxiliar};
    line-height: ${theme.typography.lineHeight.auxiliar};
    color: ${theme.colors.gray.Cinza_5};
  }

  button {
    all: unset;
    cursor: pointer;
    white-space: nowrap;
    font-size: ${theme.typography.fontSize.auxiliar};
    font-weight: ${theme.typography.fontWeight.bold};
    color: ${theme.colors.blue.Azul_link};
  }

  @media (max-width: 479px) {
    align-items: flex-start;

    .confirmation-content {
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }
  }
`;

// Enquanto o clique no link ainda não terminou de buscar o que precisa pra
// abrir o modal (ver prop `loading`) - mesma técnica de rotating border do
// RemoveSpinner (ver ../planilha-dropzone/styles.js), em verde.
export const LinkSpinner = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;

  border-top: 1px solid ${theme.colors.green.Verde_AgroReceita};
  border-bottom: 1px solid ${theme.colors.green.Verde_AgroReceita};
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;

  animation: rotating 0.7s linear infinite;

  @keyframes rotating {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;
